// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {LimitResolver} from '@app/features/app/utils/LimitResolverAdapter';
import {isLimitToggleEnabled} from '@app/features/app/utils/LimitUtils';
import {getVoiceContextEntranceSoundScope} from '@app/features/notification/utils/EntranceSoundScopes';
import {http} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';
import VoiceConnectionManager from '@app/features/voice/engine/VoiceConnectionManager';
import EntranceSoundLibrary from '@app/features/voice/state/EntranceSoundLibrary';

const logger = new Logger('VoiceEntranceSoundManager');

export async function playEntranceSound(): Promise<void> {
	const channelId = VoiceConnectionManager.channelId;
	if (!channelId) return;
	const hasEntranceSounds = isLimitToggleEnabled(
		{feature_voice_entrance_sounds: LimitResolver.resolve({key: 'feature_voice_entrance_sounds', fallback: 0})},
		'feature_voice_entrance_sounds',
	);
	if (!hasEntranceSounds) {
		return;
	}
	if (!EntranceSoundLibrary.loaded) {
		await EntranceSoundLibrary.load().catch(() => {});
	}
	const scope = getVoiceContextEntranceSoundScope(VoiceConnectionManager.guildId);
	const resolved = EntranceSoundLibrary.resolveForScope(scope);
	if (!resolved) {
		return;
	}
	try {
		await http.post(Endpoints.VOICE_CHANNEL_ENTRANCE_SOUND(channelId), {body: {sound_id: resolved.sound.id}});
		logger.debug('Entrance sound play requested', {soundId: resolved.sound.id, scopeKind: resolved.scope.kind});
	} catch (error) {
		logger.warn('Failed to request entrance sound play', {error});
	}
}
